import React, {useState, useMemo} from 'react'
import { SelectMarket } from 'app/components'
import { COMPETITION_URL } from 'app/@common/constants'
import { useAppMarketSelector } from './@hooks'
import { useContextSelector } from 'use-context-selector'
import { CompetitionAnalyzerReportExecutionContext } from 'app/pages/Competition/Analyzer2.1/Providers'
import { ParityReportExecutionContext } from 'app/pages/Parity/Analyzer2.1/Providers'
import { PackagesReportExecutionContext } from 'app/pages/Packages/Analyzer2.1/Providers'
import { getSection } from 'app/utils'


// isClearable (opt-in, default false): permite volver a "all markets" tras elegir uno. Lo activan
// el BI y Parity (CU-869fdfej3) — Competition/Packages mantienen el comportamiento de siempre (una vez
// elegido un market no se puede vaciar), que es el que asumen sus filtros guardados.
export default function AppHeaderMarket({ url= COMPETITION_URL.MARKET, isClearable=false }) {

    const { market, setMarket, setCurrency } = useAppMarketSelector()
    const [totalOptions, setTotalOptions] = useState(0)
    
    const section = useMemo(() => getSection(window.location.href), [])
    const ReportExecutionContext = section === 'competition' 
        ? CompetitionAnalyzerReportExecutionContext 
        : section === 'packages' 
            ? PackagesReportExecutionContext 
            : ParityReportExecutionContext
    const idReportExecution = useContextSelector(ReportExecutionContext, ({ state }) => state?.idReportExecution)

    return <div className={`select-market-header`}>
        <SelectMarket
            isMulti={false}
            isClearable={isClearable}
            method='POST'
            urlAjax={url}
            value={market || null}
            extraParams={{
                ...idReportExecution && { id_report_execution: idReportExecution }
            }}
            onChange={res => {
                setMarket({ market: res?.value || null })
                res?.currency && setCurrency({ currency: res?.currency })
            }}
            onAjax={options => {
                setTotalOptions(options?.length)
                if (options.length === 1) {
                    const single = options[0]
                    setMarket({ market: single.value })
                    single.currency && setCurrency({ currency: single.currency })
                }
                return options
            }}
            totalOptions={totalOptions}
        />
    </div>
}